<template>
  <div class="exam-detail" ref="examDetail">
    <div class="quizze" v-for="(exercise, index) in results" :key="index" :index="index" ref="exam">
      <div class="title">
        <div class="tag">
          <span>{{index + 1}}</span>
        </div>
        <span v-if="exercise.userAnswer === null" class="no-data">（未作答）</span>
        <van-speaker :id="index" class="primary" v-if="exercise.audio" :src="exercise.audio" />
      </div>
      <component
        :is="quizzes[exercise.code]"
        :is-exam="true"
        :auto-play="false"
        :mode="exercise.mode"
        :exercise="exercise"
        :is-done="true"
        :is-show-explain="true"
        :index="index"
        :ignore-case="isIgnoreCase"
        :user-answer="results[index].userAnswer">
      </component>
    </div>
  </div>
</template>

<script>
import 'vanthink-components/icon/iconfont.css';

import TYLJ from 'vanthink-components/components/quiz/TYLJ/TYLJ-U.vue';
import JXZH from 'vanthink-components/components/quiz/JXZH/JXZH-U.vue';
import KY from 'vanthink-components/components/quiz/KY/KY-U.vue';
import DX from 'vanthink-components/components/quiz/DX/DX-U.vue';
import QHLJ from 'vanthink-components/components/quiz/QHLJ/QHLJ-U.vue';
import MED from 'vanthink-components/components/quiz/MED/MED-U.vue';
import BQWZ from 'vanthink-components/components/quiz/BQWZ/BQWZ-U.vue';
import WK from 'vanthink-components/components/quiz/WK/WK-U.vue';
import CHXZ from 'vanthink-components/components/quiz/CHXZ/CHXZ-U.vue';
import DCTX from 'vanthink-components/components/quiz/DCTX/DCTX-U.vue';
import SK from 'vanthink-components/components/quiz/SK/SK-U.vue';
import HYDC from 'vanthink-components/components/quiz/HYDC/HYDC-U.vue';
import DCPX from 'vanthink-components/components/quiz/DCPX/DCPX-U.vue';
import YDLJ from 'vanthink-components/components/quiz/YDLJ/YDLJ-U.vue';
import THXZ from 'vanthink-components/components/quiz/THXZ/THXZ-U.vue';
import XCTK from 'vanthink-components/components/quiz/XCTK/XCTK-U.vue';
import WXTK from 'vanthink-components/components/quiz/WXTK/WXTK-U.vue';
import BS from 'vanthink-components/components/quiz/BS/BS-U.vue';
import TK from 'vanthink-components/components/quiz/BQ/BQ-U.vue';

import VanSpeaker from 'vanthink-components/components/common/Speaker.vue';
import AudioPlayer from '@/services/audio-player';

export default {
  props: {
    results: {
      type: Array,
      default: () => [],
    },
    projectCode: {
      type: String,
      default: '',
    },
  },
  components: {
    VanSpeaker,
  },
  data() {
    return {
      quizzes: {
        QHLJ,
        KY,
        DX,
        TYLJ,
        JXZH,
        MED,
        BQWZ,
        WK,
        CHXZ,
        DCTX,
        SK,
        HYDC,
        DCPX,
        THXZ,
        YDLJ,
        XCTK,
        WXTK,
        BS,
        TK,
      },
    };
  },
  computed: {
    isIgnoreCase() {
      return this.projectCode === 'Chinese';
    },
  },
  methods: {
    setAnchor(index, { autoPlay = true }) {
      const el = this.$refs.exam[index];
      this.$refs.examDetail.scrollTop = el ? el.offsetTop : 0;
      if (this.results[index].audio && autoPlay) {
        AudioPlayer.stopAll();
        AudioPlayer.play(this.results[index].audio);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  .exam-detail {
    height: calc(100% - 55px);
    overflow-y: scroll;
    .title {
      margin-top: 25px;
      /deep/ .speaker {
        margin-left: 5px;
      }
      .tag {
        position: relative;
        left: 0;
        display: inline-block;
        width: 50px;
        height: 30px;
        border-radius: 0 14px 14px 0;
        line-height: 30px;
        font-size: 18px;
        text-align: center;
        color: #fff;
        background-color: $primary;
      }
      .no-data {
        font-size: 24px;
        vertical-align: middle;
        color: $danger;
      }
    }
    .quizze {
      border-bottom: 1px solid #ececec;
    }
    /deep/ .dx-container {
      .wrong {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
      }
    }
    /deep/ .hydc-container {
      padding: 30px 30px;
    }
    /deep/ .dcpx-container {
      padding-bottom: 20px;
      .explain {
        margin-top: 30px!important;
      }
      .main {
        margin: 0 auto 0;
      }
    }
    /deep/ .dctx-container {
      padding: 10px 0;
      .main {
        margin-top: 0!important;
        .text-input {
          margin-top: 0!important;
        }
        .explain {
          margin-top: 30px;
        }
        .text {
          margin-top: 0!important;
        }
      }
    }
    /deep/ .chxz-container {
      margin-bottom: 20px;
      .title {
        margin-top: 0px!important;
      }
    }
    /deep/ .ydlj-container, .wxtk-container {
      height: 600px;
    }
    /deep/ .hydc-container, .dcpx-container,
    .ydlj-container, .wxtk-container, .dx-container,
    .bqwz-container, .qhlj-container, .xctk-container,
    .jxzh-container {
      font-family: STFangsong, NSimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
      .parse {
        font-size: 18px;
        .parse-text {
          width: 60px;
        }
        .parse-content {
          width: calc(100% - 60px);
          pre {
            font-family: STFangsong, NSimSun, "Helvetica Neue", Helvetica, Arial, sans-serif;
            line-height: 2;
          }
        }
      }
    }
  }
</style>
